import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1422Model } from "../kymw1422.model";
import { WPublishedGoodsModel } from "../vo/w-published-goods.model";
import { WPublishedPageModel } from "../vo/w-published-page.model";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";

interface GetParentChildPageResponse {
  WPublishGoods: {
    PCode: string;
    GuideGoodsName: string;
    GuideStandardName: string;
    WPublishPages: {
      PageNum: number;
      PageInfo: string;
      KomaID: string;
      ParentChildDiv: string;
    }[];
  }[];
}

/**
 * W掲載商品ページ情報を取得するサービス
 *
 * @export GetParentChildPageService
 * @class GetParentChildPageService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetParentChildPageService extends PlessJsonResponderSub<GetParentChildPageResponse> {
  private model: KYMW1422Model;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetParentChildPageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.koma.orderCode,
        MediumType: this.model.koma.mediumType,
        CoopCode: this.model.koma.coopCode,
        KomaID: this.model.koma.komaId,
        PageNum: Number(this.model.koma.pageNum)
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetParentChildPageService
   */
  execute(model: KYMW1422Model, successFunc?: () => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getParentChildPage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetParentChildPageService
   */
  success(data: GetParentChildPageResponse): void {
    this.model.wPublishedGoodsList = data.WPublishGoods.map(goods => (new WPublishedGoodsModel(
      goods.PCode,
      goods.GuideGoodsName,
      goods.GuideStandardName,
      this.model.koma.pageNum,
      this.model.koma.pageInfo,
      goods.WPublishPages.map((page, index) => new WPublishedPageModel(
        PlessViewUtilsSub.padding(page.PageNum.toString(), 3, '0', 1),
        page.PageInfo,
        page.KomaID,
        page.ParentChildDiv,
        index
      ))
    )));

    if (this.successFunc) {
      this.successFunc();
    }
  }
}

